"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _withContainer = require("./withContainer");

var _withContainer2 = _interopRequireDefault(_withContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgVisibleSecondary = function SvgVisibleSecondary(props) {
    return _react2.default.createElement(
        "svg",
        Object.assign({ width: "1em", height: "1em", viewBox: "0 0 32 32" }, props),
        _react2.default.createElement(
            "g",
            { transform: "translate(0 5)", fill: "currentColor", fillRule: "nonzero" },
            _react2.default.createElement("circle", { cx: 16, cy: 11, r: 3.8 }),
            _react2.default.createElement("path", { d: "M31.3 9.15C27.21 3.42 21.78.26 16 .26 10.22.26 4.79 3.42.7 9.16a3.22 3.22 0 000 3.69c4.09 5.73 9.52 8.89 15.3 8.89 5.78 0 11.21-3.16 15.3-8.9a3.22 3.22 0 000-3.69zM29.64 11a1 1 0 01-.17.55c-3.65 5.13-8.43 8-13.47 8-5.04 0-9.82-2.87-13.47-8a.94.94 0 01-.17-.55 1 1 0 01.17-.55C6.18 5.32 11 2.5 16 2.5s9.82 2.82 13.47 8a.94.94 0 01.17.5z" })
        )
    );
};

exports.default = (0, _withContainer2.default)(SvgVisibleSecondary);